import * as actionTypes from '../actions/actionTypes';

import  { updateObject } from '../../shared/utility';

const initialState = {
    data: []
};

const setCurrentData = (state, action) => {
    return updateObject(state, { data: action.data});
};



const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_DATA: return setCurrentData(state, action);
        default:
            return state;
    }
};

export default reducer;